module.exports = __webpack_public_path__ + "img/Z86Q_02.bd28c0ee.jpg";